import React from 'react';
import { useLang } from '../context/LanguageContext';
import { PageHeader } from '../components/PageHeader';
import ContactStrip from '../components/ContactStrip';
import LegalBody from '../components/LegalBody';
import SEO from '../components/SEO';
import { getSeo, SEO_KEYWORDS } from '../data/seo';
import { DISCLAIMER } from '../data/legal';

// Disclaimer / Haftungsausschluss — final client-provided German version (legally binding).
// English is a convenience translation; the German version prevails.
const Disclaimer = () => {
  const { lang } = useLang();
  const seo = getSeo('disclaimer', lang);

  return (
    <div>
      <SEO title={seo.title} description={seo.description} path="/disclaimer" lang={lang} keywords={SEO_KEYWORDS[lang]} />
      <PageHeader label={lang === 'de' ? 'Haftungsausschluss' : 'Disclaimer'} title={lang === 'de' ? 'Haftungsausschluss' : 'Disclaimer'} />
      <section className="bg-white py-16 lg:py-24">
        <div className="container-wide max-w-3xl" data-testid="disclaimer-content">
          {lang === 'en' && (
            <p className="mb-8 text-[13px] text-slate-500 italic">Convenience translation — the legally binding version of this disclaimer is the German one.</p>
          )}
          <LegalBody blocks={lang === 'de' ? DISCLAIMER.de : DISCLAIMER.en} />
        </div>
      </section>
      <ContactStrip />
    </div>
  );
};

export default Disclaimer;
